/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import { Link } from 'react-router-dom';

const getErrorForField = function(source, field, options) {
    let error = null,
        errorMsg = '',
        parts = [],
        key = '',
        keys = [];

    if (field.match(/\./)) {
        parts = field.split(/\./);
        field = parts[0];
        key = parts[1];
        if (parts.length > 2) {
            keys = parts.slice(1)
        }
    }

    if (source.errors !== null) {
        if (source.errors.errors && source.errors.errors.validation) {
            if (source.errors.errors.validation[field]) {
                // a field may return a string (for general errors) or an array/object for specific errors
                // so to guarantee you get the right version pass in isString in the options
                if (!_.isString(source.errors.errors.validation[field]) && (options && options.isString === true)) {
                    return null;
                }
                if (_.isArray(source.errors.errors.validation[field])) {
                    if ((options && _.isNumber(options.index)) && source.errors.errors.validation[field][options.index]) {
                        error = source.errors.errors.validation[field][options.index];
                        for (let objKey in error) {
                            if (error.hasOwnProperty(objKey)) {
                                errorMsg = error[objKey];
                            }
                        }
                        return (
                            <div className="fieldset-error">
                                <ul className="fieldset-error-list">
                                    <li className="error-list-item">{errorMsg}</li>
                                </ul>
                            </div>
                        );
                    } else if (!options){
                        return (
                            <div className="fieldset-error">
                                <ul className="fieldset-error-list">
                                {source.errors.errors.validation[field].map(function(error, i){
                                    let key = null;
                                    for (key in error) {
                                        return (<li key={'error-' + i} className="error-list-item">{error[key]}</li>);
                                    }
                                }, this)}
                                </ul>
                            </div>
                        );
                    }

                } else {
                    if (options && _.isNumber(options.index)) {
                        if (source.errors.errors.validation[field][options.index]) {
                            error = source.errors.errors.validation[field][options.index];
                            if (key !== '') {
                                error = source.errors.errors.validation[field][options.index][key];
                            }
                        } else {
                            return null;
                        }
                        for (var objKey in error) {
                            errorMsg = error[objKey];
                        }
                    } else {
                        if (keys.length) {
                            let marker = errorMsg;
                            for (let i = 0; i < keys.length; ++i) {
                                marker = marker[keys[i]];
                            }
                        } else {
                            if (key !== '') {
                                errorMsg = source.errors.errors.validation[field][key];
                            } else {
                                errorMsg = marker;
                            }
                        }
                    }

                    for (let objKey in error) {
                        errorMsg = error[objKey];
                    }

                    return (
                        <div className="fieldset-error">
                            {errorMsg}
                        </div>
                    );
                }
            }
        }
    }

    return error;
};

class ErrorHelper {

    static getErrorForField(source, field, options) {
		return getErrorForField(source, field, options);
	}

    static getStateErrorForField(source, field, options) {
        return getErrorForField(source, field, options);
    }

    static getRecurlyErrorForField(errors, field) {

        if (_.isEmpty(errors)) {
            return "\u00a0";
        }

        if (_.isArray(errors.fields) && errors.fields.indexOf(field) !== -1) {
            switch (errors.code) {
                case 'validation':
                    return "Required field";

                case 'invalid-parameter':
                    return "Invalid value";

                case 'api-error':
                    return errors.message;

                case 'paypal-canceled':
                    return "Paypal billing canceled";

                case 'paypay-error':
                    return errors.message;

            }
        } else {
            return "\u00a0";
        }

    }

    static buttonHasError(source, button) {
        let key = '',
            subKey = '',
            error = null,
            keySearch = (source, button) => {
                for (let key in source) {
                    if (_.isArray(source[key]) || _.isObject(source[key])) {
                        return keySearch(source[key], button);
                    } else {
                        if (button.fieldMappings !== undefined && button.fieldMappings.indexOf(key) !== -1) {
                            return true
                        }
                    }
                }
            };

        if (source.app.errors.api.length) {
            for (let i = 0; i < source.app.errors.api.length; ++i) {
                error = source.app.errors.api[i].error;
                if (error !== null && error.errors !== undefined && error.errors.validation !== undefined) {
                    return keySearch(error.errors.validation, button);
                }
            }
        }

        if (source.app.errors.local.length) {
            for (let i = 0; i < source.app.errors.local.length; ++i) {
                error = source.app.errors.local[i].error;
                if (error !== null && error.errors !== undefined && error.errors.validation !== undefined) {
                    return keySearch(error.errors.validation, button);
                }
            }
        }

        return false;

    }

    static extractErrors(collection, type) {

        let errors = [],
            item = null,
            genericMsg = '',
            newError = {};

        for (let i = 0; i < collection.length; ++i) {
            item = collection[i];
            if (item.social) {
                item = item.social;
            }
            // check inputs
            if (item && item.errCount !== undefined && parseInt(item.errCount, 10) > 0) {
                if (item.lastPullInfo && item.lastPullInfo.length) {
                    if (parseInt(item.lastPullInfo[0].success, 10) === 0) {
                        newError = {
                            name: (item.name) ? item.name : 'Error',
                            message: item.lastPullInfo[0].message,
                            unixTs: item.lastPullInfo[0].unixTs
                        };
                        if (!_.findWhere(errors, newError)) {
                            errors.push(newError);
                        }
                    } else {
                        // add a generic error -- input log only sticks around for a few days
                        if (type === 'input') {
                            genericMsg = "We're unable to retrieve this feed.";
                        }
                        newError = {
                            name: (item.name) ? item.name : 'Error',
                            message: genericMsg
                        };
                        if (!_.findWhere(errors, newError)) {
                            errors.push(newError);
                        }
                    }
                }
            }
        }

        return errors;
    }

};

export default ErrorHelper;
